import { render, staticRenderFns } from "./ProductList2.vue?vue&type=template&id=6b589e40&scoped=true&"
import script from "./ProductList2.vue?vue&type=script&lang=js&"
export * from "./ProductList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b589e40",
  null
  
)

export default component.exports